import { render } from "./HelciumPayment.vue?vue&type=template&id=ad705d38&scoped=true"
import script from "./HelciumPayment.vue?vue&type=script&lang=js"
export * from "./HelciumPayment.vue?vue&type=script&lang=js"

import "./HelciumPayment.vue?vue&type=style&index=0&id=ad705d38&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad705d38"]])

export default __exports__